import type { I18nText } from "@shared";

interface Props {
  id: string;
  label: string;
  value: I18nText | null;
  onChange: (next: I18nText) => void;
  /** Texte long : rend deux zones de texte au lieu de deux champs. */
  multiline?: boolean;
  required?: boolean;
}

/**
 * Saisie d'un texte multilingue, FR et EN COTE A COTE.
 *
 * Choix delibere plutot qu'un systeme d'onglets : quand on saisit dix objets
 * d'affilee, voir les deux langues en meme temps evite un aller-retour par
 * champ. Le FR est obligatoire (il sert de repli), l'EN facultatif.
 */
export default function I18nFields({
  id,
  label,
  value,
  onChange,
  multiline = false,
  required = true,
}: Props) {
  const fr = value?.fr ?? "";
  const en = value?.en ?? "";

  function update(lang: "fr" | "en", text: string): void {
    onChange({ fr, en, [lang]: text } as I18nText);
  }

  return (
    <fieldset className="i18n-fields">
      <legend className="form__label">{label}</legend>

      <div className="i18n-fields__grid">
        <div className="i18n-fields__cell">
          <label className="i18n-fields__lang" htmlFor={`${id}-fr`}>
            Français {required && <span className="i18n-fields__required">obligatoire</span>}
          </label>
          {multiline ? (
            <textarea
              id={`${id}-fr`}
              className="form__input form__input--area"
              value={fr}
              rows={3}
              onChange={(e) => {
                update("fr", e.target.value);
              }}
            />
          ) : (
            <input
              id={`${id}-fr`}
              className="form__input"
              type="text"
              value={fr}
              onChange={(e) => {
                update("fr", e.target.value);
              }}
            />
          )}
        </div>

        <div className="i18n-fields__cell">
          <label className="i18n-fields__lang" htmlFor={`${id}-en`}>
            English <span className="i18n-fields__optional">optionnel</span>
          </label>
          {multiline ? (
            <textarea
              id={`${id}-en`}
              className="form__input form__input--area"
              value={en}
              rows={3}
              onChange={(e) => {
                update("en", e.target.value);
              }}
            />
          ) : (
            <input
              id={`${id}-en`}
              className="form__input"
              type="text"
              value={en}
              onChange={(e) => {
                update("en", e.target.value);
              }}
            />
          )}
        </div>
      </div>
    </fieldset>
  );
}
